import { render, staticRenderFns } from "./PlanVideo.vue?vue&type=template&id=47eb53a2&scoped=true&"
import script from "./PlanVideo.vue?vue&type=script&lang=js&"
export * from "./PlanVideo.vue?vue&type=script&lang=js&"
import style0 from "./PlanVideo.vue?vue&type=style&index=0&id=47eb53a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eb53a2",
  null
  
)

export default component.exports